import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import cn from 'classnames';
import {Link, useLocation} from 'react-router-dom';

import {PATHS} from '../../../Routes';
import {useComputedReservationDetails} from 'context/computedReservationDetails';
import {useReservation} from 'context/reservation';

import {getHousingName} from 'utils/reservation';
// import User from 'components/acommon/User';
import Language from 'components/acommon/Language';
// import StyledIcon from 'components/acommon/StyledIcon';
import Button from 'components/acommon/Button';

import {StyledHeader, Container, Logo, ButtonsWrapper} from './styled';
import styles from './Header.module.sass';

type HeaderProps = {
  title?: string
  onlyForDesktop?: boolean;
};
const Header = ({title, onlyForDesktop}: HeaderProps) => {
  const {t} = useTranslation();
  const location = useLocation();

  // const notAuthorized = true;
  const [visibleNav, setVisibleNav] = useState(false);
  const {data} = useReservation();
  const housingName = getHousingName(data);
  // const match = useRouteMatch();
  const {hasUpselling} = useComputedReservationDetails();

  return (
    <StyledHeader onlyForDesktop={onlyForDesktop}>
      <Container>
        <Logo>
          <Link className="logoName" to={{pathname: '/', state: location.state}}>
            {title || housingName}
          </Link>
        </Logo>

        <ButtonsWrapper>
          {hasUpselling && (
            <Button
              className="experiencesButton"
              to={{pathname: PATHS.experiences}}
              size="medium"
              stroke
            >
              {t('experiences')}
            </Button>
          )}
          {/* feature
            <NavLink className="link" to="/support" activeClassName={styles.active}>
              Support
            </NavLink> */}
          <Language className={cn(styles.language, styles.desktopOnly)} />

          {/*------------------- Future Feature ------------------*/}
          {/*{notAuthorized ? (*/}
          {/*  <User />*/}
          {/*) : (*/}
          {/*  <Link to={{pathname: match.url, search: '?login=true'}} className="login">*/}
          {/*    <StyledIcon name="avatarAccountIcon" size="24" color="##6B6B95" />*/}
          {/*  </Link>*/}
          {/*)}*/}
          {/*------------------- Future Feature ------------------*/}
        </ButtonsWrapper>

        <button
          className={cn(styles.burger, {[styles.active]: visibleNav})}
          onClick={() => setVisibleNav(!visibleNav)}
        ></button>
      </Container>
    </StyledHeader>
  );
};

export {Header};
